/**
 * APIsation Stellair
 * <div><img height=\"50\" alt=\"logo\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAAAsCAYAAAB8K3ZrAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEvklEQVR4nO1b7XHbMAwFff0fbRCP4A2iDeoNom6gDapOUI+gbKBOUI3gbKBuoEyAHl3AhSl+yaITJeG74yW2KBDEI0gQpBUiQsbtoZTaAsAeAEYA6BBxdDWaSbkxlFIFANQA8F209AIADSIebK1vPkLH1wqlVAUAgyDkGQC+kbf8VEodlVLlRH3tKbmkLQCgDX3U5iVSRioFPdfe09B3+osOALasRyYkPSE1GXokw+/o88FSd0uEIJUyk5KekILIOPLIFySVnvdK8qhef85rSlroNeROE4GIA0nWRGnj966W6FkLAA96jcmkpEWRQlomZYXIpLwSlFK72JYyKbdHRy3sY1vKpNwYiKgjsT968adUSxBfQhXI7bYUbwOHfL5oImMCHZX91l6jd/lElLRxceFJnni7odgZPaWVO1GHrJ7j75XuLSrSsUogqyRbNY52UOzgGyqt2Nmfdv02wTuDjCO9vKdGa0OQVQkhD/9xv1pSmlAfZsrjHXpvDliybecZ5CcdbISMggzfLrQQHTp5TSblbJdWGppzXka9rVnv/MwQNvoM7FBiLwTX742UG5JdkrfwtFRhRDLSJIVZO16hQCUaL4xnn5IUwzZy9hlCMxG/uBWj3btwexrvbd7y2UnBS+84UvEGFfxSPXfasjS8t3laiBRyczNw4HOIg20+dnS6FmcYsnQRGdrGrEPfmVOOGY0OrjVjEYl4Ocr3C0fEaHqbjxQyuuygJqchfWSY6NTLEi32ItQcDHJsC651oReydoYuUkep+1UzjI8UFr6IcRHulXjZuQkpgpDRESCYUcxktNO061wwhSec61xBymB7LnRk70y2F5MKDIuF/e9gLb6bkCI2WbrsAjIPLv3EaJ0Y2+JNTEzl0NlGCtresRAzxvQltmxE9pIPZVIgdK5Q098fZsrBBCLWlDu6p4sIJ5DeD3QzpArIOIo2m5n9e0LE1iObpzSYk3T0YZPqYGYmvlJ1Z2cN8FUc2Wn+33uHikGGfSFyo9Poom0fOBMclXAMYUNz4qtBXKl5FkemIXDyUxqT5XQzdLfJ8SLkyQbSkCJG2UMCeex1McYOjm6GMMz9EjliAMYa73mG7GTg8xQ9Z0Nsvt+DOevT0jXs1NaNjxDmEJ4MTAp37OqFis4ETt4WaailA+AIl9PhhwGTwvNyvaBjHAH9iqwfTUpgYZ4TqLwLAk+kIGInws7ZxJCXcKjpXXjJizgKiiXGZsxrvHtO1PVmkGf05zh+ZsgIFDbeUUQVE+YycbF7BttA4XYeY8ilwXYX2d6b4kwKecsTKd7HzNXaQ5RS2jiPMZs4ASbjUW4IHW20tqiLwukn+tiRt7pk7K7YNL4dLGkDmW9qbclAWg9qkRcaXSkGT+5LnllPMq3G5efWJsfIPVnPJ8R5xijkNeK5N/cVmV4q59SPyn1ZGqktqfTeyN7K7505n0CWuDLkcRsyBX8IkFsY9QeLrgOtJxMC3g0porMVjS7zHKGndSSYgAvdZiGPOFhS4a2RbQ7Jsena0wDj34XYSLHeZuE+RpKym1M/VD7Vz+uUUg39qkonQle7xuQbkitEJmWFyKSsEJmUFSKTskJkUlaIzxYS6z2RLvoSRso7CekAAH8B6V1xAty4lCQAAAAASUVORK5CYII=\"/><br/><p> Réorganisation des API et améliorations diverses </p></div>
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Représentation des données de création d'un patient
 */
export interface PatientCreationRequest { 
    nom: string;
    prenom: string;
    dateNaissance: string;
    rangNaissance: number;
    nirAssure: string;
    regime: PatientCreationRequest.RegimeEnum;
    caisse: string;
    centre: string;
    naturePieceJustifAmo: PatientCreationRequest.NaturePieceJustifAmoEnum;
}
export namespace PatientCreationRequest {
    export type RegimeEnum = 'REGIME_0' | 'REGIME_1' | 'REGIME_2' | 'REGIME_3' | 'REGIME_4' | 'REGIME_5' | 'REGIME_6' | 'REGIME_7' | 'REGIME_8' | 'REGIME_9' | 'REGIME_10' | 'REGIME_12' | 'REGIME_14' | 'REGIME_15' | 'REGIME_16' | 'REGIME_17' | 'REGIME_90' | 'REGIME_91' | 'REGIME_92' | 'REGIME_93' | 'REGIME_94' | 'REGIME_95' | 'REGIME_96' | 'REGIME_99' | 'REGIME_INCONNU';
    export const RegimeEnum = {
        _0: 'REGIME_0' as RegimeEnum,
        _1: 'REGIME_1' as RegimeEnum,
        _2: 'REGIME_2' as RegimeEnum,
        _3: 'REGIME_3' as RegimeEnum,
        _4: 'REGIME_4' as RegimeEnum,
        _5: 'REGIME_5' as RegimeEnum,
        _6: 'REGIME_6' as RegimeEnum,
        _7: 'REGIME_7' as RegimeEnum,
        _8: 'REGIME_8' as RegimeEnum,
        _9: 'REGIME_9' as RegimeEnum,
        _10: 'REGIME_10' as RegimeEnum,
        _12: 'REGIME_12' as RegimeEnum,
        _14: 'REGIME_14' as RegimeEnum,
        _15: 'REGIME_15' as RegimeEnum,
        _16: 'REGIME_16' as RegimeEnum,
        _17: 'REGIME_17' as RegimeEnum,
        _90: 'REGIME_90' as RegimeEnum,
        _91: 'REGIME_91' as RegimeEnum,
        _92: 'REGIME_92' as RegimeEnum,
        _93: 'REGIME_93' as RegimeEnum,
        _94: 'REGIME_94' as RegimeEnum,
        _95: 'REGIME_95' as RegimeEnum,
        _96: 'REGIME_96' as RegimeEnum,
        _99: 'REGIME_99' as RegimeEnum,
        INCONNU: 'REGIME_INCONNU' as RegimeEnum
    };
    export type NaturePieceJustifAmoEnum = 'AUCUNE' | 'PAPIER' | 'DISTANT' | 'CARTE_VITALE';
    export const NaturePieceJustifAmoEnum = {
        AUCUNE: 'AUCUNE' as NaturePieceJustifAmoEnum,
        PAPIER: 'PAPIER' as NaturePieceJustifAmoEnum,
        DISTANT: 'DISTANT' as NaturePieceJustifAmoEnum,
        CARTEVITALE: 'CARTE_VITALE' as NaturePieceJustifAmoEnum
    };
}